import { getAssetPath } from '@/constants/configs';
import { surinameConfigs } from '@/constants/tenant-configs/suriname';

import { AppConfigurations } from '@/types/app-configurations';

export const surinameDutchConfigs: AppConfigurations = {
  ...surinameConfigs,
  links: {
    ...surinameConfigs.links,
    privacyPolicyURL: 'https://nl.republicbanksr.com/about/privacy-policy',
    termsAndConditionsURL:
      'https://launchworthy.com/rblonline-sr2/legal-dutch.html',
    termsOfUseURL: getAssetPath('/tnc/republiconboard-tnc-sur-nl.pdf'),
    appTermsAndConditionsURL: getAssetPath(
      '/tnc/republiconboard-tnc-sur-nl.pdf',
    ),
    biometricConsentURL: getAssetPath(
      '/bio-consent/republiconboard-biometric-consent-sur-nl.pdf',
    ),
  },
};
